import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';

import * as styles from './codeOt.module.scss';
import { ArticleTemplateQuery, SanityCodeOt } from '../../../../../graphql-types';
import { usePageContext } from '../../../../hooks/contexts/usePageContext';
import { LocaleLink } from '../../../../components/2.0version/localeLink/LocaleLink';
import { sanitizeSlug } from '../../../../utils/sanitizeSlug';
import Bag from '../../../../../static/svg/bag.svg';
import { URLS } from '../../../../../constants';

interface ICodeOtProps {
  data?: SanityCodeOt;
  otList?: ArticleTemplateQuery['allIngenieOt'];
}

export const CodeOt = ({ data, otList }: ICodeOtProps) => {
  const { lang, defaultLang } = usePageContext();
  const { sanityTranslations } = useStaticQuery(QUERY);

  const ot = otList?.nodes?.find((element) => element?.codeOt === data?.code);
  if (!ot) return null;

  const parentSlug = ot?.parentRubriques?.[0]?.slug ? `/${ot?.parentRubriques?.[0]?.slug}` : '';
  const agenda = ot?.key === 'Y';
  const prefixUrl = agenda ? URLS.agenda.url : URLS['preparez-votre-sejour'].url;
  const slug = `${prefixUrl}${parentSlug}/${sanitizeSlug(ot?.libelle?.fr)}`;

  return (
    <div className={styles.wrapper}>
      <LocaleLink to={slug}>
        <div className={styles.card}>
          <div className={styles.image}>
            <img alt="tours-tourisme" src={ot?.medias?.[0]?.url ?? ''} loading="lazy" />
          </div>
          <div className={styles.pictosPartners}>
            {ot?.pictosPartners?.map((picto, index) => (
              <img
                key={picto?.url ?? index}
                src={picto?.url ?? ''}
                alt={picto?.alt ?? 'logo placeholder'}
              />
            ))}
          </div>
          <div>
            <div className={styles.header}>
              <Bag />
              <h3 className={styles.title}>{ot?.libelle?.[lang] ?? ot?.libelle?.[defaultLang]}</h3>
            </div>
            <p
              className={styles.description}
              dangerouslySetInnerHTML={{
                __html:
                  ot?.descriptifs?.[0]?.contenu?.[lang] ??
                  ot?.descriptifs?.[0]?.contenu?.[defaultLang],
              }}
            />
            <button className={styles.buttonLink} type="button">
              {sanityTranslations?._rawLinkLabel?.[lang]}
            </button>
          </div>
        </div>
      </LocaleLink>
      <div className={styles.line} />
    </div>
  );
};
const QUERY = graphql`
  query CodeOt {
    sanityTranslations {
      _rawLinkLabel
    }
  }
`;
